function SendRequest(path, message) {
    this.path = path;
    this.message = message;
}

module.exports = SendRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/send/send-request.js
// module id = 317
// module chunks = 0